import type { Answers } from "./answers";
import type { Recorded } from "./participant";

/**
 * LA TYPOLOGIE DE CELUI QUI REGARDE — celle qui décide de la CONFIGURATION SERVIE.
 *
 * ⚠️ DEUX PORTÉES POUR UNE MÊME CASCADE, ET LES CONFONDRE COÛTE DANS LES DEUX SENS.
 *
 *   LECTURE   ce que le site affiche : les textes, les couleurs, et jusqu'aux ÉTAPES du
 *             parcours. Elle suit la typologie du PARTICIPANT — c'est la règle du
 *             produit, où la typo prime même sur la langue.
 *   ÉCRITURE  ce que le panneau modifie. Elle suit le sélecteur « en tant que » de la
 *             barre, et lui seul.
 *
 * ⚠️ ELLES ONT DÉJÀ ÉTÉ CONFONDUES, DANS L'AUTRE SENS. L'étape typologie appelait
 * `setTypo` : un clic de participant déplaçait alors le sélecteur de l'organisateur, qui
 * se retrouvait à écrire les surcharges d'un exposant sans un mot. On a donc coupé le
 * lien — mais rien n'a été mis à la place côté lecture, et un participant a continué de
 * recevoir la configuration COMMUNE quelle que soit sa réponse. Le module société restait
 * servi à des typologies pour lesquelles l'organisateur l'avait explicitement coupé.
 *
 * ⚠️ RIEN EN MODE ORGANISATEUR, et c'est ce qui rend la séparation sûre. Il configure ;
 * ce qu'il voit doit obéir à SON sélecteur, y compris quand il est lui-même inscrit à
 * l'événement qu'il prépare — sinon sa propre typologie viendrait décider de ce que le
 * panneau lui montre, et il écrirait ailleurs qu'il ne croit.
 *
 * Pure, donc la règle se vérifie sans navigateur : c'est une ligne dont l'erreur ne se
 * voit qu'à l'écran, et seulement sur un événement qui surcharge quelque chose.
 */
export function viewerTypoOf(
  mode: "visitor" | "organiser",
  answers: Answers,
  recorded: Recorded | undefined,
): number | null {
  if (mode !== "visitor") return null;
  /* Ce qu'on vient de répondre, sinon ce que le serveur détient — l'ordre de préséance
     de tout ce tunnel. Le premier fait basculer la configuration au clic même ; le second
     la garde pour qui revient sans repasser par l'étape. */
  return answers.typoId ?? recorded?.typoId ?? null;
}
